import React from 'react';
import './TextInput.scss';

class TextInput extends React.Component<any, any> {
    render() {
        return <div className='textInputContainer'>
            <span className='label'>{this.props.label} </span>
            {this.props.required && <span className='greyedOut'>(måste anges)</span>}
            <br />
            <input onChange={this.props.onChange} type="text" value={this.props.value} /><br />
        </div>
    }
}

export default TextInput